// Webpack Imports
import 'bootstrap';

( function ( $ ) {
	'use strict';

	// Focus Search if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );

	$('.btn-calc-slide').on('click', function (e) {
		$('.btn-calc-slide').removeClass('active');
		$(this).addClass('active');
	})

	$('[data-toggle="tooltip"]').tooltip();

	$('.add-cart').on('click', function(e) {
		e.preventDefault();
		let thisbtn = $(this);
		let item = $(this).data('title');
		let act = $(this).data('action');
		//let par = $(this).parent();

		$.ajax({
			type:'POST',
			url:ajax_url,
			data: {
				item: item,
				act: act,
				security: ajax_nonce,
				action: 'cart_update'
			},
			success: function(response){
				//alert(response);
				$('.sc-icon span').html(response);
				if (act == 'add') {
					$(thisbtn).html('<i class="fa fa-times"></i>');
					$(thisbtn).data('action','remove');
					//$(par).html('<a href="#" class="btn btn-lyfe btn-small add-cart" data-action="remove" data-title="' + item + '"><i class="fa fa-times"></i></a>');
				}
				if (act == 'remove') {
					$(thisbtn).html('<i class="fas fa-cart-arrow-down"></i>');
					$(thisbtn).data('action','add');
					//$(par).html('<a href="#" class="btn btn-lyfe btn-small add-cart" data-action="add" data-title="' + item + '"><i class="fas fa-cart-arrow-down"></i></a>');
				}
			}
		});
	});

}(jQuery));

let OrderManager = (function () {
	"use strict";

	let orderedItemsList;
	let orderedItems = [];
	let carousel;
	let address = [];
	let rowOrderItems = '.row-order-steps';
	let rowOrderItemsLine = '.row-order-steps-line';
	let rowOrderItemsDesc = '.row-order-steps-description';
	let the_form;

	let init = function () {
		carousel = $('#carousel-order');

		if (!carousel.length) {
			return;
		}

		the_form = $('#f-orders');

		carousel.on('slide.bs.carousel', function (item) {
			if (item.direction === 'left') {
				$(rowOrderItems + ' > div').eq(item.to).addClass('active');
				$(rowOrderItemsLine + ' > div').eq(item.to).addClass('active');
				$(rowOrderItemsDesc + ' > div').eq(item.to).addClass('active');
			} else {
				$(rowOrderItems + ' > div').eq(item.from).removeClass('active');
				$(rowOrderItemsLine + ' > div').eq(item.from).removeClass('active');
				$(rowOrderItemsDesc + ' > div').eq(item.from).removeClass('active');
			}
		})

		_handleItemsCounter();
		_handleGotoDelivery();
		_handleGotoSummary();
		_handleSubmit();
		_handleItemsFilter();
		_changeDeliveryTypeDependencies();
	};

	let _handleItemsCounter = function () {
		$('.product input:checkbox').change(function() {
			$('.order-counter .badge').text($('.product input:checkbox:checked').length);
		});
	}

	let _handleGotoDelivery = function () {
		$('.js-order-goto-delivery').on('click', function (e) {
			e.preventDefault();
			orderedItemsList = $('.product input:checkbox:checked');

			if (orderedItemsList.length === 0) {
				alert('Wybierz najpierw przynajmniej jeden materiał.');

				return;
			}

			let itemsListSummary = $('#fso-sm-articles');

			$(orderedItemsList).each(function(key, item) {
				let itemText = $(item).val();
				itemsListSummary.append($('<li>').text(itemText));
				orderedItems.push(itemText);
			})

			_nextSlide();
		})
	};

	let _changeDeliveryTypeDependencies = function () {
		$('input[name="delivery_type"]').change(function() {
			if (this.value === 'representative') {
				$('input[name="street"]').removeAttr('required');
				$('input[name="post_code"]').removeAttr('required');
				$('.address-data').collapse('hide');
			} else {
				$('input[name="street"]').prop('required', true);
				$('input[name="post_code"]').prop('required', true);
				$('.address-data').collapse('show');
			}
		});
	}

	let _handleGotoSummary = function () {
		$('.js-order-goto-summary').on('click', function (e) {
			e.preventDefault();
			let errors = '';
			address = {};

			address.first_name = $('input[name="first_name"]').val().trim();
			address.last_name = $('input[name="last_name"]').val().trim();
			address.street = $('input[name="street"]').val().trim();
			address.post_code = $('input[name="post_code"]').val().trim();
			address.city = $('input[name="city"]').val().trim();
			address.phone = $('input[name="phone"]').val().trim();
			//address.delivery_type = $('input[name="delivery_type"]:checked').val().trim();
			address.delivery_type = $('input[name="delivery_type"]').val().trim();

			if (address.first_name === '') {
				errors += "\n" + 'Nie podano imienia.';
			}

			if (address.last_name === '') {
				errors += "\n" + 'Nie podano nazwiska.';
			}

			if (address.delivery_type === 'postage') {
				if (address.street === '') {
					errors += "\n" + 'Nie podano ulicy i numeru.';
				}

				if (address.post_code === '') {
					errors += "\n" + 'Nie podano kodu pocztowego.';
				}
			}

			if (address.city === '') {
				errors += "\n" + 'Nie podano miejscowości.';
			}

			if (address.phone === '') {
				errors += "\n" + 'Nie podano numeru telefonu.';
			}

			if (address.delivery_type === '') {
				errors += "\n" + 'Nie wybrano metody dostarczenia materiałów.';
			}

			//
			$('#ordered-items-list li').each(function(i)
			{
				orderedItems.push($(this).text());
			});

			if (orderedItems.length === 0) {
				alert('Wybierz najpierw przynajmniej jeden materiał.');
				return;
			}
			//

			if (errors !== '') {
				alert(errors);

				return;
			}

			let itemsListSummary = $('#fso-sm-articles');
			$.each(orderedItems, function(index, value) {
				itemsListSummary.append($('<li>').text(value));
			})

			orderedItems.forEach(function (value) {
				$(the_form).append('<input type="hidden" name="product[]" value="' + value + '" />');
			})

			for (const [key, value] of Object.entries(address)) {
				$('#fso-sm-' + key).text(value);
			}

			_nextSlide();
		})
	};

	let _handleSubmit = function () {
		the_form.on('submit', function (e) {
			e.preventDefault();

			let form_data = the_form.serializeArray();
			form_data.push( { "name" : "security", "value" : ajax_nonce } );

			$.ajax({
				url : ajax_url,
				type : 'post',
				data : form_data,
				success : function( response ) {
					_nextSlide();
					$('.sc-icon span').html('0');
					the_form.trigger('reset');
				},
				fail : function( err ) {
					alert('Wystąpił nieoczekiwany błąd. Spróbuj ponownie za chwilę.');
				}
			});
		})
	};
	
	let _nextSlide = function () {
		carousel.carousel('next');
	}
	
	let _handleItemsFilter = function () {
		$('.items-filter').click(function (e) {
			let filtersList = [];

			$('.items-filter:checked').each(function(){
				filtersList.push($(this).val());
			});

			if (filtersList.length === $('.items-filter').length) {
				$('.product').collapse('show')
			} else {
				$('.product').each(function (i, item) {
					let productItems = $(item).data('categories');

					let hasAll = filtersList.every(elem => productItems.indexOf(elem) > -1)

					if (hasAll) {
						$(item).collapse('show');
					} else {
						$(item).collapse('hide');
					}
				});
			}
		})
	}

	return {
		init: init
	};
})();

OrderManager.init();

let JoinEvents = (function () {
	"use strict";

	let the_form;

	let init = function () {
		the_form = $('#f-join-event');

		if (!the_form.length) {
			return;
		}

		_handleSubmit();
	};

	let _handleSubmit = function () {
		the_form.on('submit', function (e) {
			e.preventDefault();

			let form_data = the_form.serializeArray();
			form_data.push( { "name" : "security", "value" : ajax_nonce } );

			$.ajax({
				url : ajax_url,
				type : 'post',
				data : form_data,
				success : function( response ) {
					the_form.html('<p class="text-center">Twoje zgłoszenie zostało zapisane. Dziękujemy!</p>');
				},
				fail : function( err ) {
					alert('Wystąpił nieoczekiwany błąd. Spróbuj ponownie za chwilę.');
				}
			});
		})
	};

	return {
		init: init
	};
})();

JoinEvents.init();



let webinarMessenger = (function() {
	let formMessenger = '#f-webinar-messenger';
	let messageDisapearAfter = 4000; // ms
	let dashboard = $('.webinar-sent-questions');
	let dashboardList = dashboard.find('ol');

	let init = function() {
		_initListeners();
	};

	let _initListeners = function () {
		_listenMessageSend();
	}

	let _listenMessageSend = function () {
		let the_form = $(formMessenger);

		if (!the_form) {
			return;
		}

		let elem_success = $('.js-webinar-messenger-success');

		the_form.on('submit', function (e) {
			e.preventDefault();

			$.post(
				ajax_url,
				$(this).serialize(),
				function (data) {
					if (data.error) {
						alert(data.error);
					} else {
						$('#f_chat_msg').val('');
						elem_success.collapse('show');
						_appendMessageToDashboard(data.question_content);

						window.setTimeout(function() {
							elem_success.collapse('hide');
						}, messageDisapearAfter);
					}
				}
			)
				.fail(function() {
					alert('Wystąpił nieoczekiwany problem. Spróbuj ponownie za chwilę.');
				});
		})
	}

	let _appendMessageToDashboard = function (message) {
		dashboardList.append('<li>' + message + '</li>');
		dashboard.collapse('show');
	}

	return {
		init: init
	};
})();

webinarMessenger.init();
/**
 * Events like webinars END
 */